// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NumberBox_wrapper__GtiWM","number":"NumberBox_number__wQR0G","shimmer":"NumberBox_shimmer__oyQn7"};